import { type IImageParagraph, type IParagraph, isImageParagraph } from '@pressreader/content-types';

/**
 * Finds the image paragraph associated with an image ID.
 * Returns undefined when the image ID is missing or no image paragraph matches.
 */
export function findImageParagraphByImageId(paragraphs: IParagraph[] | null | undefined, imageId: string | undefined): IImageParagraph | undefined {
    if (!imageId) {
        return undefined;
    }

    return paragraphs?.find((paragraph): paragraph is IImageParagraph => isImageParagraph(paragraph) && paragraph.image?.id === imageId);
}
